import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const MobileMenuItemsContainerDefaultBox = styled.div`
`;

const MobileMenuItemContainerCasino888Box = styled(MobileMenuItemsContainerDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
`;

export const MobileMenuItemsContainerBox = styledByTheme(MobileMenuItemsContainerDefaultBox)
    .forCasino888(MobileMenuItemContainerCasino888Box)
    .apply();